import { Form, Col, Modal, Row } from 'react-bootstrap';
import { ReactComponent as ReactTruckIcon } from '../../../../assets/icons/truck.svg';
import getInvoiceStatusText from '../../../../utils/getInvoiceStatusText';
import {
    StyledDivInvoiceDelivery,
    StyledSpan,
    StyledCloseButton,
} from './styles';
import getMaxAvailabilityDate from '../../../../utils/getMaxAvailabilityDate';
import getFreightValue from '../../../../utils/getFreightValue';
import getTotalInvoice from '../../../../utils/getTotalInvoice';
import { formatCurrency } from '../../../../utils/strings';
import useInvoiceFreight from '../../../../hooks/useInvoiceFreight';

interface FeedbackInvoiceModalProps {
    show: boolean;
    onHide: () => void;
    selectedInvoice: any;
}

export default function FeedbackInvoiceModal({
    show,
    onHide,
    selectedInvoice,
}: FeedbackInvoiceModalProps) {
    const willPickup = selectedInvoice.addressType === 'pickup';

    const noDeliveryMessage = willPickup
        ? `Disponível para entrega em ${getMaxAvailabilityDate(
              selectedInvoice,
          )}`
        : 'Prazo de entrega indisponível';

    const totalInvoiceValue = getTotalInvoice(selectedInvoice);

    const { data: freightPercentage = 0 } = useInvoiceFreight(
        selectedInvoice.id,
        selectedInvoice.freightPercentage,
    );

    const freightValue = getFreightValue(totalInvoiceValue, freightPercentage);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Feedback do pedido
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <StyledSpan className="d-block">
                            <strong>Número do pedido: </strong>
                            {selectedInvoice.id}
                        </StyledSpan>
                        <StyledSpan className="d-block">
                            <strong>Status: </strong>
                            {getInvoiceStatusText(
                                selectedInvoice.status,
                                selectedInvoice.paymentMethod,
                            )}
                        </StyledSpan>
                        <StyledSpan className="d-block">
                            <strong>Valor total: </strong>
                            {formatCurrency(totalInvoiceValue + freightValue)}
                        </StyledSpan>
                    </Col>
                    <Col>
                        <StyledDivInvoiceDelivery className="float-right text-center">
                            {selectedInvoice.deliveryDeadline ? (
                                <>
                                    <strong>Prazo de entrega</strong>
                                    <div className="d-block mt-2">
                                        <ReactTruckIcon
                                            fill="#707070"
                                            width="18"
                                            height="18"
                                            className="mr-1 mt-n1"
                                        />
                                        {`${selectedInvoice.deliveryDeadline} dias úteis`}
                                    </div>
                                </>
                            ) : (
                                <strong>{noDeliveryMessage}</strong>
                            )}
                        </StyledDivInvoiceDelivery>
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-4">
                        <Form.Group controlId="formBasicComment">
                            <Form.Label>Mensagem</Form.Label>
                            <Form.Control
                                as="textarea"
                                disabled
                                value={selectedInvoice.approvalFeedback}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <StyledCloseButton onClick={onHide}>Fechar</StyledCloseButton>
            </Modal.Footer>
        </Modal>
    );
}
